import { jsx, jsxs } from "react/jsx-runtime";
import React from "react";
export function SequenceName({
  sequenceName,
  sequenceLength,
  isProtein,
  showAminoAcidUnitAsCodon
}) {
  const proteinUnits = showAminoAcidUnitAsCodon ? "codons" : "AAs";
  return /* @__PURE__ */ jsxs("div", { className: "sequenceNameText", children: [
    /* @__PURE__ */ jsxs("span", { title: sequenceName, children: [
      sequenceName,
      " "
    ] }),
    /* @__PURE__ */ jsx("br", {}),
    /* @__PURE__ */ jsx("span", { children: isProtein ? `${Math.floor(sequenceLength / 3)} ${proteinUnits}` : `${sequenceLength} bps` })
  ] }, "sequenceNameText");
}
